<!--
 * @Author: Junjie
 * @Date: 2024-03-22 11:18:35
 * @LastEditTime: 2024-03-22 11:23:13
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-wf-web/src/views/equipment/account/modules/components/BleConfig.vue
-->
<template>
  <div class="c-tabs-panel">
    <wf-dev-ble-config-form :deviceData="deviceData" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import WfDevBleConfigForm from '../../vue/modules/WfDevBleConfigForm.vue'

  export default {
    name: 'BleConfig',
    components: {
      WfDevBleConfigForm
    },
    props: {
      deviceData: {
        type: Object,
        default: () => { }
      }
    },
    // 定义属性
    data () {
      return {

      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {

    }
  }
</script>

<style lang='scss' scoped>


</style>
